import { useContext } from "react";
import { motion } from "framer-motion";
import Contact from "../components/Contact";
import { LanguageContext } from "../App";
import { IMAGES } from "../translations";

export default function ContactPage() {
  const { t } = useContext(LanguageContext);

  return (
    <>
      {/* Hero contatti — foto intera, responsive su tutti gli schermi */}
      <div
        data-testid="page-hero"
        className="relative flex items-end overflow-hidden"
        style={{
          minHeight: "clamp(300px, 70vh, 700px)",
          backgroundColor: "#1A1917",
        }}
      >
        {/* Foto intera con object-fit contain */}
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `url(${IMAGES.contact_hero})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center center",
            backgroundSize: "contain",
            backgroundColor: "#1A1917",
          }}
        />

        {/* Gradient overlay */}
        <div
          className="absolute inset-0"
          style={{
            background: "linear-gradient(to top, rgba(26,25,23,0.85) 0%, rgba(26,25,23,0.3) 40%, transparent 100%)",
          }}
        />

        {/* Testo */}
        <div className="relative z-10 w-full px-5 md:px-12 pb-10 md:pb-20 max-w-7xl mx-auto">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="font-['Manrope',sans-serif] text-[10px] md:text-xs uppercase tracking-[0.3em] text-[#7B907F] mb-3"
          >
            {t.contact.contact_overline}
          </motion.p>
          <motion.h1
            initial={{ opacity: 0, y: 25 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.35 }}
            className="font-['Cormorant_Garamond',serif] text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light text-[#FDFBF7] tracking-tight leading-tight"
          >
            {t.contact.contact_headline}
          </motion.h1>
        </div>
      </div>

      <Contact />
    </>
  );
}
